import { MotifModal, MotifModalBody, MotifModalFooter, MotifModalHeader } from '@ey-xd/motif-react'
import React from 'react'
import '@/components/Modal/ConfirmationModal/confirmationModal.scss';
import Button from '@/components/Form/Button/Button';
import {useTranslation} from 'react-i18next';
import { CANCEL_BUTTON_VARIANT, OK_BUTTON_VARIANT } from '@/components/Images/CommonImages';
import { CommonModalHeader } from '@/components/Modal/CommonModalHeader/CommonModalHeader';

type Props = {
  isVisible: boolean;
  setIsVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleOkButton: (event: React.MouseEvent<HTMLButtonElement>) => void;
  confirmationMessage: string;
  unitToDelete?: any;
}

export default function ConfirmationModalUnit({isVisible, setIsVisible, handleOkButton, confirmationMessage,unitToDelete}: Props) {
  const {t} = useTranslation();

  return (
    <>
      <MotifModal
        onClose={() => setIsVisible(false)}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="confirmationModalWrapper creditor_disabling_model">
          <MotifModalHeader
            headerIcon={CommonModalHeader()}            
          ></MotifModalHeader>
          <MotifModalBody style={{ paddingTop: "0px" }}>
            <div className="">
              {t(confirmationMessage)}{" "}
              <strong>{unitToDelete}</strong>
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={t("global.globalActions.ok")}
              variant={OK_BUTTON_VARIANT}
              className="cancelBtnModal"
              onClickHandler={handleOkButton}
            />
            <Button
              label={t("global.globalActions.cancel")}
              variant={CANCEL_BUTTON_VARIANT}
              className="cancelBtnModal"
              onClickHandler={handleOkButton}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );}

